export const FilterOption: Readonly<any> = {
    Package: 0,
    Tag: 1,
    Package_Or_Tag: 2
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/filterOption.ts